var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8558 5.07961H8.17212C8.24249 4.19311 8.24249 3.30238 8.17212 2.41589C8.0878 1.79429 7.81256 1.21421 7.38441 0.755753C7.23604 0.6566 7.05744 0.612984 6.88006 0.632471C6.70267 0.651959 6.53786 0.733361 6.41456 0.86236C6.41456 0.86236 6.44916 2.30024 6.44916 2.62899C6.26851 3.22379 5.93762 3.76205 5.48842 4.19174C5.2908 4.37387 3.98853 4.88473 3.69894 5.07961V11.2948L9.24489 11.2857C10.2748 11.2857 10.5954 10.0427 9.93153 9.92706L9.97977 9.78499C10.64 9.71396 11.1755 8.61295 10.3732 8.38165L10.4215 8.24869C11.048 8.17766 11.6499 7.10315 10.8158 6.83723L10.8631 6.70428C11.6982 6.56222 12.0351 5.22991 11.1655 5.22991L10.8558 5.07961ZM0.120972 5.96748H2.80468V12.1828H0.120972V5.96748Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeButton);
export default __webpack_public_path__ + "static/media/like-button.481a1acb87dd68c771aac1d10d123e46.svg";
export { ForwardRef as ReactComponent };